<template>
<div style="padding: 0 10px;">

  <el-select placeholder="订单编号(可选)" style="margin-left: 10px;" v-model="orderId" @change="orderChange" clearable>
    <el-option v-for="item in orderList" :key="item.id" :label="item.order_no" :value="item.id" ></el-option>
  </el-select>
  <el-button style="margin: 10px 0 10px 10px" @click="addItemRow(1)">添加物料行</el-button>
  <el-button style="margin: 10px 0 10px 10px" @click="getMaterialListByOrderId">订单物料匹配</el-button>
  <div style="height:370px;overflow-y: auto;overflow-x: hidden">
  <el-row class="box">
    <el-col :span="7">物料名称</el-col>
    <el-col :span="3">供应商</el-col>
    <el-col :span="3">订单需求数量</el-col>
    <el-col :span="3">已有采购单数量</el-col>
    <el-col :span="4">预估市场价</el-col>
    <el-col :span="4">采购数量</el-col>
  </el-row>
  <el-row v-for="item in materialItemList" :key="item.id" class="row" >
    <el-col :span="7" class="tip">
      <el-select v-model="item.materialId" @change="changeSupplier(item)" clearable style="width: 100%;padding-right: 5px">
        <el-option v-for="material in materialList" :key="material.id" :label="material.name" :value="material.id"></el-option>
      </el-select>
    </el-col>
    <el-col :span="3" class="tip">
      <el-select v-model="item.supplierId"  placeholder="供应商" clearable >
        <el-option v-for="supplier in item.supplierList" :key="supplier.id"  :label="supplier.name" :value="supplier.id" ></el-option>
      </el-select>
    </el-col>
    <el-col :span="3" class="tip">{{item.demandCnt}}</el-col>
    <el-col :span="3" class="tip">{{item.havePurchaseCnt}}</el-col>
    <el-col :span="4" style="text-align: center">
      <el-input-number  :min="0" v-model="item.estimatePrice" :precision="2" placeholder="市场价"></el-input-number>
    </el-col>
    <el-col :span="4" style="text-align: center">
      <el-input-number :min="0"  v-model="item.purchaseCnt" placeholder="采购数量"></el-input-number>
    </el-col>
    <div class="close" @click="removeItemRow(item.nanoid)">
      <el-icon>
        <ElIconClose></ElIconClose>
      </el-icon>
    </div>
  </el-row>
  </div>
  <div style="margin-top: 10px; margin-bottom: 10px;" >
    <el-input type="textarea" rows="4" v-model="remark" placeholder="采购单备注"></el-input>
  </div>
  <el-button type="primary" style="width: 500px" @click="addOrderPurchase">生成采购单</el-button>
  <div style="color:red;margin-top: 10px; font-size: 15px">注意：选择多个供应商时会生成多个采购单，相同供应商合并为同一采购单</div>
</div>
</template>

<script>
import {nanoid} from 'nanoid'
export default {
  inject: ['$fn'],
  name: "MakePurchaseMaterial",

  data() {
    return {
      remark:'',
      orderId:'',
      materialDetail:{},
      orderList:[],
      // supplierList:[],
      supplierAllList:[],
      materialItemList:[],
      materialAllList:[],
      materialList:[],
    }
  },
  created() {
    this.getOrderList();
    this.getMaterialList()
    this.addItemRow(7);
    this.getAllSupplier();
  },
  methods: {
    //获取订单编号 根据创建时间降序 前100条
    async getOrderList(){
      this.orderList = await this.$http('rebuildPurchaseService.getOrders');
    },

    //订单改变
    async orderChange(){
      this.materialItemList = []
      this.addItemRow(7);
      if(!this.orderId){
        await this.getMaterialList();
      }
    },

    //获取所有物料
    async getMaterialList(){
      this.materialAllList = await this.$http('rebuildPurchaseService.getMaterialList')
      this.materialList = this.materialAllList;
    },

    //获取所有供应商
    async getAllSupplier(){
      this.supplierAllList = await this.$http('rebuildSupplierService.getAll')
    },

    //订单物料匹配,根据订单获取所需物料
    async getMaterialListByOrderId(){
      if (!this.orderId){
        return this.$message.error('请先输入订单号');
      }
      let params = {order_id: this.orderId}
      await this.$http('rebuildPurchaseService.getMaterialListByOrderId',params).then(data=>{
        if (this.orderId){
          this.materialItemList = data
        }
      })
    },

    //根据物料编号获取供应商和数量
    changeSupplier(item){
      item.supplierList = [];
      if (!item.materialId){
        return;
      }
      //获取物料信息
      let materialType = '';
      this.materialAllList.forEach(data => {
        if (data.id === item.materialId) {
          materialType = data.type
        }
      })
      //获取对应的供应商信息
      this.supplierAllList.forEach(data =>{
        for (const supplyType of data.supply_types) {
          if (supplyType === materialType) {
            item.supplierList.push(data)
          }
        }
      })

      if(item.materialId) {
        this.materialList.forEach(data => {
          if (data.id == item.materialId) {
            item.demandCnt = data.demandCnt;
            item.havePurchaseCnt = data.havePurchaseCnt;
          }
        })
      }
      if(!item.materialId){
        delete item.demandCnt;
        delete item.havePurchaseCnt;
      }

    },
    //生成采购单
    async addOrderPurchase(){

      var i = 1;
      let needMaterialItemList = [];
      let isNull = true;
      let materialIdSet = new Set();
      for (const materialItem of this.materialItemList) {
        if(materialItem.materialId){
          isNull = false;
        }
      }
      if(isNull){
        return this.$message.error('不能生成空的采购单');
      }
      for (const materialItem of this.materialItemList) {
        if(materialIdSet.has(materialItem.materialId)){
          this.$message.error('第' + i +'行，物料重复');
          return;
        }
        if(!materialItem.materialId && !materialItem.estimatePrice && !materialItem.purchaseCnt){
          i = i + 1
          continue;
        }
        if(!materialItem.supplierId){
          this.$message.error('第' + i +'行，供应商为空');
          return;
        }
        if(!materialItem.materialId){
          this.$message.error('第' + i +'行，物料名称为空')
          return;
        }
        if(!materialItem.estimatePrice){
          this.$message.error('第' + i +'行，预估市场价为空')
          return;
        }
        if(!materialItem.purchaseCnt){
          this.$message.error('第' + i +'行，采购数量为空')
          return;
        }
        i = i + 1;
        needMaterialItemList.push(materialItem);
        materialIdSet.add(materialItem.materialId);
      }
      let params ={
        materialItemList:needMaterialItemList,
        remark:this.remark,
        orderId:this.orderId,
        supplierId:this.supplierId,
      }
      await this.$http('rebuildPurchaseService.addPurchase',params)
      this.$fn.closeWindow();
      this.$fn.search();
      this.$message.success('生成采购单成功')
    },

    addItemRow(cnt) {
      for(var i=0;i<cnt;i++){
        this.materialItemList.push({
          nanoid: nanoid(),
        })
      }
    },
    removeItemRow(nanoid) {
      let index = this.materialItemList.findIndex(item => item.nanoid === nanoid);
      this.materialItemList.splice(index, 1);
    }

  }
}
</script>

<style scoped>

.box {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  text-align: center;
}

.row {
  margin-top: 15px;
  padding: 0;
}

.row .tip {
  text-align: center;
  font-size: 14px;
}

.close {
  position: absolute;
  top: 5px;
  right: 10px;
  font-size: 18px;
  cursor: pointer;
}

</style>